import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme) => ({
	warningColor: {
		color: theme.palette.custom.creditRequest.warningIcon,
		fontSize: 24,
		[theme.breakpoints.up("sm")]: {
			fontSize: 20,
			display: "flex",
			alignItems: "flex-start",
		},
	},
	warningText: {
		lineHeight: 1.2,
		[theme.breakpoints.up("sm")]: {
			lineHeight: 1.45,
			fontSize: 15,
		},
	},
	errorColor: {
		color: theme.palette.custom.error,
		fontSize: 50,
	},
	heading: {
		fontWeight: 700,
		fontSize: "1.3rem",
	},
	closeIcon: {
		fontSize: 30,
		position: "absolute",
		right: theme.spacing(-1),
		top: theme.spacing(-1.2),
	},
	warningRow: {
		paddingTop: theme.spacing(1.5),
		[theme.breakpoints.up("sm")]: {
			paddingTop: theme.spacing(2),
			paddingLeft: theme.spacing(1),
		},
	},
	courierRow: {
		marginBottom: theme.spacing(2.5),
		marginTop: theme.spacing(1),
	},
	courierField: {
		backgroundColor: theme.palette.custom.creditRequest.fieldBackground,
		"& .MuiOutlinedInput-input, & .MuiSelect-select": {
			paddingTop: theme.spacing(1.675),
			paddingBottom: theme.spacing(1.675),
		},
		"& .MuiInputLabel-root:not(.MuiInputLabel-shrink)": {
			transform: "translate(14px, 13px) scale(1)",
		},
	},
}));
